import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Body from "./containers/Body";
import Overview from "./containers/Overview";
import Login from "./containers/authentication/Login";
import DrivePage from "./containers/apps/drive/DrivePage";
import RecentPage from "./containers/apps/drive/RecentPage";
import FavoritesPage from "./containers/apps/drive/FavoritesPage";
import TrashPage from "./containers/apps/drive/TrashPage";
import SharedPage from "./containers/apps/drive/SharedPage";
import TeamPage from "./containers/apps/drive/TeamPage";
import PublicSharePage from "./containers/apps/drive/PublicSharePage";
import AdminLayout from "./containers/admin/AdminLayout";
import AdminDashboard from "./containers/admin/AdminDashboard";
import AdminMembers from "./containers/admin/AdminMembers";
import AdminMemberDetail from "./containers/admin/AdminMemberDetail";
import AdminTeams from "./containers/admin/AdminTeams";
import AdminTrash from "./containers/admin/AdminTrash";
import AdminActivity from "./containers/admin/AdminActivity";
import NotFound from "./containers/NotFound";

const BaseRouter = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Body />
          </ProtectedRoute>
        }
      >
        <Route index element={<Overview />} />
        <Route path="drive" element={<DrivePage />} />
        {/* Same component, scoped to a folder — the id drives the fetch. */}
        <Route path="drive/folders/:folderId" element={<DrivePage />} />
        <Route path="recent" element={<RecentPage />} />
        <Route path="favorites" element={<FavoritesPage />} />
        <Route path="trash" element={<TrashPage />} />
        <Route path="teams/:teamId" element={<TeamPage />} />
        {/* Distinct from drive/folders/:folderId so the sidebar and breadcrumb
            can tell a team folder apart from a personal one from the URL alone,
            without an extra lookup. */}
        <Route path="teams/:teamId/folders/:folderId" element={<DrivePage />} />
        <Route path="shared" element={<SharedPage />} />
      </Route>

      {/* Org admin console. Its own shell (no drive sidebar/navbar), and its own
          guard — though every admin endpoint re-checks the role server-side. */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="members" element={<AdminMembers />} />
        <Route path="members/:userId" element={<AdminMemberDetail />} />
        <Route path="teams" element={<AdminTeams />} />
        <Route path="trash" element={<AdminTrash />} />
        <Route path="activity" element={<AdminActivity />} />
      </Route>

      <Route path="auth">
        <Route path="login" element={<Login />} />
      </Route>

      {/* Public: no session required. */}
      <Route path="/s/:token" element={<PublicSharePage />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default BaseRouter;
